export const fieldName = {
    ID: 'fid',
    STREET: 'address1',
    HOUSENUMBER: 'address2',
    ADDITIONAL: 'additional_info',
    ZIPCODE: 'zipcode',
    CITY: 'city',
    COUNTRY_NAME: 'country_name',
    COUNTRY_ID: 'country_id',
};

export const defaultValues = [
    {
        name: fieldName.ID,
    },
    {
        name: fieldName.COUNTRY_ID,
    },
    {
        name: fieldName.COUNTRY_NAME,
        tk: 'NEW_CHECKOUT_SHIPPING_COUNTY',
        isReq: true,
    },
    {
        name: fieldName.STREET,
        tk: 'NEW_CHECKOUT_SHIPPING_STREET',
        isReq: true,
    },
    {
        name: fieldName.HOUSENUMBER,
        tk: 'NEW_CHECKOUT_SHIPPING_NUMBER',
        isReq: true,
    },
    {
        name: fieldName.ADDITIONAL,
        tk: 'NEW_CHECKOUT_SHIPPING_ADDITIONAL',
        isReq: false,
    },
    {
        name: fieldName.ZIPCODE,
        tk: 'NEW_CHECKOUT_SHIPPING_ZIPCODE',
        isReq: true,
    },
    {
        name: fieldName.CITY,
        tk: 'NEW_CHECKOUT_SHIPPING_CITY',
        isReq: true,
    },
];

export const getDefaultAddress = (countryName, countryId) => {
    const defaultAddress = defaultValues.reduce((o, key) => {
        let val = '';

        if (key.name === fieldName.COUNTRY_NAME) {
            val = countryName;
        } else if (key.name === fieldName.COUNTRY_ID) {
            val = countryId;
        }

        return Object.assign(o, {
            [key.name]: val,
        });
    });
    return defaultAddress;
};
